import { useNavigate, useParams } from "react-router";

import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";

export const useDynamicPageParams = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  return {
    pageSlug: slug ?? "",
    needRefresh: false,
    checkInternetConnection: () => {
      return;
    },
    redirectToNotFound: () => navigate("/not-found"),
  };
};

export const useScreenFocusEffect = (effect: () => void | (() => void)) => {
  useMountEffect(effect);
};
